(() => {
  const root = document.querySelector('[data-halloween-buy]');
  if (!root) return;

  const form = root.querySelector('.dfy-hb-form');
  const options = [...root.querySelectorAll('[data-hb-option]')];
  const variantInput = root.querySelector('[data-hb-variant]');
  const submit = root.querySelector('.dfy-hb-submit');
  const submitLabel = root.querySelector('[data-hb-submit-label]');
  const feedback = root.querySelector('[data-hb-feedback]');
  const shopRoot = root.dataset.shopRoot || '/';
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      document.body.classList.toggle('dfy-hb-in-view', entries[0].isIntersecting);
    }, {threshold: 0.05}).observe(root);
  }
  const bundle = {
    product: 10434148499738,
    mainVariant: 52943953166618,
    caseVariant: 52944082305306,
    cleanerVariant: 52944079487258,
    deal: 'd2At',
    version: 'c39e989c-04bd-4241-857b-f2d8c52558cb',
    bars: {
      1: {id: '0hit', caseGift: 'KRFE'},
      2: {id: '71D6', caseGift: 'cuSL', cleanerGift: 'DtJC'},
      3: {id: 'Iv-W', caseGift: 'oJhA', cleanerGift: 'Bmse'}
    }
  };

  const selected = () => options.find(option => option.classList.contains('is-selected'));
  const render = () => {
    const current = selected();
    options.forEach(option => {
      const active = option === current;
      option.setAttribute('aria-checked', String(active));
      option.tabIndex = active ? 0 : -1;
      option.querySelector('.dfy-hb-benefits')?.setAttribute('aria-hidden', String(!active));
    });
    if (!current) return;
    const pack = Number(current.dataset.pack);
    const hasCleaner = pack > 1;
    variantInput.value = current.dataset.hbVariantId;
    submit.disabled = current.classList.contains('is-unavailable');
    submitLabel.textContent = submit.disabled ? 'Sold out' : `Add ${pack} ${pack === 1 ? 'Device' : 'Devices'}${hasCleaner ? ' + Free Cleaner' : ''} · ${current.dataset.hbPrice}`;
    const summary = root.querySelector('.dfy-hb-summary');
    summary.classList.toggle('is-starter', !hasCleaner);
    root.querySelector('[data-hb-summary-item-label]').textContent = `${pack} ${pack === 1 ? 'mouthpiece' : 'mouthpieces'} · regular value`;
    root.querySelector('[data-hb-summary-item-value]').textContent = ({1: '$59.98', 2: '$119.96', 3: '$179.94'})[pack];
    root.querySelector('[data-hb-summary-compare]').textContent = current.dataset.hbCompare;
    root.querySelector('[data-hb-summary-price]').textContent = current.dataset.hbPrice;
    root.querySelector('[data-hb-summary-saving]').textContent = current.dataset.hbSaving;
    root.querySelector('[data-hb-summary-saving-context]').textContent = hasCleaner ? '(incl. FREE $39.98 cleaner)' : '(starter pack discount)';
    root.querySelector('[data-hb-summary-headline]').textContent = hasCleaner ? 'Everything included. More saved.' : 'A simple start.';
    root.querySelector('[data-hb-summary-description]').textContent = hasCleaner
      ? 'Your free $39.98 Ultrasonic Cleaner is already included in the total savings. No separate coupon or extra step required.'
      : 'Your 1-device starter pack comes with a 30-night guarantee, travel case, and free U.S. shipping.';
    const reward = root.querySelector('[data-hb-reward]');
    reward.classList.toggle('is-locked', !hasCleaner);
    root.querySelector('[data-hb-reward-eyebrow]').textContent = hasCleaner ? 'YOUR HALLOWEEN REWARD IS UNLOCKED' : 'UNLOCK YOUR NEXT REWARD';
    root.querySelector('[data-hb-reward-title]').textContent = hasCleaner ? 'FREE $39.98 Ultrasonic Cleaner' : 'Add 1 more device to unlock a FREE Cleaner';
    root.querySelector('[data-hb-reward-description]').textContent = hasCleaner
      ? 'One cleaner comes with your selected bundle at no extra charge.'
      : 'Choose the 2- or 3-device Halloween bundle to get a $39.98 Ultrasonic Cleaner at no extra charge.';
    root.querySelector('[data-hb-reward-status]').textContent = hasCleaner ? 'Included' : '2+ devices';
    root.querySelector('[data-hb-trust-guarantee]').textContent = `${({1: 30, 2: 90, 3: 120})[pack]}-Night Guarantee`;
  };

  function choose(option, moveFocus = false) {
    if (option.classList.contains('is-unavailable')) return;
    options.forEach(card => card.classList.toggle('is-selected', card === option));
    render();
    if (moveFocus) option.focus();
    const url = new URL(location.href);
    url.searchParams.set('variant', option.dataset.hbVariantId);
    history.replaceState({}, '', url);
  }

  options.forEach((option, index) => {
    option.addEventListener('click', () => choose(option));
    option.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        choose(option, true);
      } else if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        const direction = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : (index + direction + options.length) % options.length;
        choose(options[nextIndex], true);
      }
    });
  });

  const bundleProperty = values => values.extra.main
    ? JSON.stringify({deal: bundle.deal, pp: bundle.product, main: true, v: bundle.version, id: values.group, bid: values.extra.bid})
    : JSON.stringify({id: values.group, deal: bundle.deal, v: bundle.version, gift: values.extra.gift});
  const getGroup = (cart, group) => cart.items.filter(item => {
    try { return JSON.parse(item.properties?.__kaching_bundles || '{}').id === group; }
    catch { return false; }
  });

  async function removeGroup(items) {
    for (const item of [...items].reverse()) {
      await fetch(`${shopRoot}cart/change.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: item.key, quantity: 0})
      });
    }
  }

  form.addEventListener('submit', async event => {
    event.preventDefault();
    const current = selected();
    if (!current || submit.disabled) return;
    const pack = Number(current.dataset.pack);
    const offer = bundle.bars[pack];
    if (!offer) return;

    submit.disabled = true;
    feedback.textContent = '';
    const group = crypto.randomUUID().replaceAll('-', '').slice(0, 10);
    const items = [
      {
        id: bundle.mainVariant,
        quantity: pack,
        properties: {__kaching_bundles: bundleProperty({group, extra: {pp: bundle.product, main: true, bid: offer.id}})}
      },
      {
        id: bundle.caseVariant,
        quantity: pack,
        properties: {__kaching_bundles: bundleProperty({group, extra: {gift: offer.caseGift}})},
        parent_id: bundle.mainVariant
      }
    ];
    if (pack > 1) items.push({
      id: bundle.cleanerVariant,
      quantity: 1,
      properties: {__kaching_bundles: bundleProperty({group, extra: {gift: offer.cleanerGift}})},
      parent_id: bundle.mainVariant
    });

    try {
      const response = await fetch(`${shopRoot}cart/add.js?kaching_bundles=true`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items})
      });
      if (!response.ok) throw new Error('Unable to add the selected bundle. Please try again.');

      const cartResponse = await fetch(`${shopRoot}cart.js`, {headers: {Accept: 'application/json'}, cache: 'no-store'});
      if (!cartResponse.ok) throw new Error('Unable to verify the cart. Please review it before checkout.');
      const lines = getGroup(await cartResponse.json(), group);
      const main = lines.find(item => item.variant_id === bundle.mainVariant);
      const cases = lines.find(item => item.variant_id === bundle.caseVariant);
      const cleaner = lines.find(item => item.variant_id === bundle.cleanerVariant);
      const total = lines.reduce((sum, item) => sum + item.final_line_price, 0);
      const valid = main?.quantity === pack && cases?.quantity === pack && cases.final_line_price === 0
        && (pack === 1 ? !cleaner : cleaner?.quantity === 1 && cleaner.final_line_price === 0)
        && total === Number(current.dataset.hbCents);
      if (!valid) {
        await removeGroup(lines);
        throw new Error('The bundle price or free gifts could not be verified. Please try again.');
      }
      location.assign(`${shopRoot}cart`);
    } catch (error) {
      feedback.textContent = error.message;
      submit.disabled = false;
    }
  });

  render();
  if (location.hash === '#halloween-bundle-options') {
    const anchor = root.querySelector('#halloween-bundle-options');
    const align = () => {
      if (location.hash !== '#halloween-bundle-options') return;
      if (Math.abs(anchor.getBoundingClientRect().top - 100) > 24) {
        anchor.scrollIntoView({block: 'start', behavior: 'auto'});
      }
    };
    setTimeout(align, 100);
    setTimeout(align, 1200);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => setTimeout(align, 100), {once: true});
    }
  }
})();
